module.exports = __webpack_public_path__ + "banquet/components/images/quantity_decrease.b480751c9c5d4b10f0990c8d694d96ab.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/quantity_decrease.png
// module id = 1041
// module chunks = 1